import Head from 'next/head';
import React, { FC } from 'react';

type Props = {
  title: string;
};

const HeadTitle: FC<Props> = ({ title }) => {
  return (
    <Head>
      <title>{`${title} - Fitquarters`}</title>
    </Head>
  );
};

export default HeadTitle;
